/** CDN 降级共享配置 */

/** SW postMessage 事件类型（CDN 成功，通知主线程更新 localStorage） */
export const SW_CDN_OK_MSG = 'CDN_OK';

/** SW postMessage 事件类型（DoH 动态域名更新） */
export const SW_CDN_DOH_MSG = 'CDN_DOH';

/** SW postMessage 事件类型（DoH 查询成功） */
export const SW_CDN_DOH_SUCCESS_MSG = 'CDN_DOH_SUCCESS';

/** SW postMessage 事件类型（DoH 查询失败） */
export const SW_CDN_DOH_FAIL_MSG = 'CDN_DOH_FAIL';

/** SW postMessage 事件类型（单次域名重试失败） */
export const SW_CDN_RETRY_FAIL_MSG = 'CDN_RETRY_FAIL';

/** SW postMessage 事件类型（域名切换成功） */
export const SW_CDN_SWITCH_SUCCESS_MSG = 'CDN_SWITCH_SUCCESS';

/** SW postMessage 事件类型（已从容灾域名切回首选 CDN） */
export const SW_CDN_SWITCHBACK_SUCCESS_MSG = 'CDN_SWITCHBACK_SUCCESS';

/** SW postMessage 事件类型（所有域名全部失败） */
export const SW_CDN_ALL_FAIL_MSG = 'CDN_ALL_FAIL';

/** 主线程 → SW：页面已就绪，请 flush 缓存的上报事件 */
export const SW_CDN_FLUSH_MSG = 'CDN_FLUSH';

/** 主线程 → SW：同步 localStorage 中记录的最近可用域名 */
export const SW_CDN_OK_DOMAIN_SYNC_MSG = 'CDN_OK_DOMAIN_SYNC';

export {
  CDN_LAST_OK_KEY, CDN_LAST_OK_TTL,
  CDN_DOH_CACHE_KEY, CDN_DOH_TTL, CDN_DOH_AES_KEY, CDN_DOH_CF_URL, CDN_DOH_GG_URL,
  MAX_RETRY_PER_RESOURCE,
  CDN_RESOURCE_PREFIXES,
  CDN_FAILURE_WINDOW_MS,
  CDN_PENDING_REQUEST_TIMEOUT_MS,
  CDN_FAILURE_THRESHOLD,
  CDN_FAILOVER_SESSION_TOKEN_KEY,
} from '@/const/cdn-failover.mjs';
